<template>
	<Col class="menu-container py-4 px-1">
		<Col class="explanation-container flex-centerize mb-1">
			{{ explanationText }}
		</Col>
		<v-list dense>
			<v-list-item
				dense
				:key="index"
				@click="item.onClick"
				:disabled="item.divider"
				v-for="(item, index) in menuItems"
				class="pl-2 flex-justify-space-between"
				:class="{ selected: item.isSelected, 'pointer-events-none': item.isSelected }"
			>
				<Row class="flex-align-center menu-item py-1 pl-0 width-100">
					<SIcon :height="18" class="mr-3" v-if="item.prependIcon" :name="item.prependIcon" :width="item.prependIconWidth" />
					{{ item.text }}
				</Row>
				<v-icon v-if="item.isSelected" class="check">mdi-check</v-icon>
			</v-list-item>
		</v-list>
	</Col>
</template>

<script>
export default {
	name: 'GroupFeatureVisibilityForNewUsersMenu',
	props: {
		menuItems: { type: Array },
		isLocked: { type: Boolean },
		isVisible: { type: Boolean },
		explanationText: { type: String },
	},
};
</script>

<style scoped lang="scss">
.explanation-container {
	height: 50px;
	padding: 10px;
	color: #292829;
	font-size: 11px;
	border-radius: 6px;
	background: #fafbfd;
	letter-spacing: 0.11px;
	border: 1px solid #e2e7f0;
}
.menu-item {
	height: 40px;
	font-size: 14px;
	border-radius: 8px;
	font-weight: normal;
	color: var(--bold-title);
	&.selected {
		background: #f6f9ff;
		border: 1px solid #dfe4ef;
	}
}
.menu-container {
	border-radius: 8px;
	background: var(--bg-color);
	border: 1px solid #d6ddea;
}
.selected {
	border-radius: 8px;
	background: #f6f9ff;
	border: 1px solid #dfe4ef;
}
.check {
	font-size: 18px;
	color: #5c8df5;
}
</style>
